import React from 'react';

import WsIconProps from './IconProps';

const Position: React.FC<WsIconProps> = ({ color = '#616893', width = 16, height = 16 }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.66663 2.66634H11.3333V5.33301H4.66663V2.66634ZM3.33329 2.66634C3.33329 1.92996 3.93025 1.33301 4.66663 1.33301H11.3333C12.0697 1.33301 12.6666 1.92996 12.6666 2.66634V5.33301C12.6666 6.06939 12.0697 6.66634 11.3333 6.66634H10.6666V7.99967H12C12.7363 7.99967 13.3333 8.59663 13.3333 9.33301V11.333V12.6663V13.9997C13.3333 14.3679 13.0348 14.6663 12.6666 14.6663C12.2984 14.6663 12 14.3679 12 13.9997V12.6663H3.99996V13.9997C3.99996 14.3679 3.70148 14.6663 3.33329 14.6663C2.9651 14.6663 2.66663 14.3679 2.66663 13.9997V12.6663V11.333V9.33301C2.66663 8.59663 3.26358 7.99967 3.99996 7.99967H5.33329V6.66634H4.66663C3.93025 6.66634 3.33329 6.06939 3.33329 5.33301V2.66634ZM6.66663 6.66634H9.33329V7.99967H6.66663V6.66634ZM3.99996 9.33301H12V11.333H3.99996V9.33301Z"
      fill={color}
    />
  </svg>
);

export default Position;
